import { ColumnDef } from '@3ddv/software-division-components/backoffice/table';
import { gsActionsColumn } from '../../shared/ui/table/gs-table.columns';
import { User } from './models/users.model';

export function buildUserColumns(
  onEdit: (user: User) => void,
  onDelete: (user: User) => void
): ColumnDef<User>[] {
  const idColumn: ColumnDef<User> = {
    id: 'id',
    header: 'Id',
    accessorFn: user => user.id,
  };

  const usernameColumn: ColumnDef<User> = {
    id: 'username',
    header: 'Username',
    accessorFn: user => user.username,
  };

  const emailColumn: ColumnDef<User> = {
    id: 'email',
    header: 'Email',
    accessorFn: user => user.email,
  };

  const typeColumn: ColumnDef<User> = {
    id: 'type',
    header: 'Type',
    accessorFn: user => user.type,
  };

  const actionsColumn = gsActionsColumn<User>({
    actions: [
      {
        id: 'edit',
        label: 'Edit',
        dataCy: user => `user-edit-button-${user.id}`,
      },
      {
        id: 'delete',
        label: 'Delete',
        destructive: true,
        dataCy: user => `user-delete-button-${user.id}`,
      },
    ],
    onSelect: (actionId, user) => {
      if (actionId === 'edit') {
        onEdit(user);
      } else if (actionId === 'delete') {
        onDelete(user);
      }
    },
    rowDataCy: user => `user-row-${user.id}`,
  });

  return [idColumn, usernameColumn, emailColumn, typeColumn, actionsColumn];
}
